import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// 引用自定义组件库
import Components from './utils/components.js'

const app = createApp(App)

app.use(router)
app.use(Components)

app.mount('#app')
